import {
    Box,
    Heading,
    Text,
    useColorModeValue,
} from '@chakra-ui/react';
import { ChatInterface } from '../ImportedItems/ChatInterface';

interface AnalysisTabProps {
    item: any;
    onOpenPreview: (page?: number) => void;
}

export function AnalysisTab({ item, onOpenPreview }: AnalysisTabProps) {
    const panelBg = useColorModeValue('white', 'gray.800');
    const borderColor = useColorModeValue('gray.200', 'gray.700');

    return (
        <Box h="calc(100vh - 180px)" display="flex" flexDirection="column" gap={4}>

            <Box bg={panelBg} p={4} borderRadius="xl" borderWidth="1px" borderColor={borderColor} shadow="sm">
                <Heading size="md">AI Analysis</Heading>
                <Text fontSize="sm" color="gray.500">Ask your agent to analyze requirements, find risks, and summarize key details.</Text>
            </Box>

            <Box
                flex={1}
                bg={panelBg}
                borderRadius="xl"
                borderWidth="1px"
                borderColor={borderColor}
                shadow="sm"
                overflow="hidden"
            >
                <ChatInterface
                    importedItemId={item.id}
                    onOpenPreview={onOpenPreview}
                    height="100%"
                />
            </Box>
        </Box>
    );
}
